import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setSandbox } from '../features/sandbox/sandboxSlice';
// import { IS_APP_SANDBOX } from "../app.config";

type Props = {
  children: React.ReactNode;
};

export const SandboxEnvironmentHandler: React.FC<Props> = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(setSandbox(IS_APP_SANDBOX));

    const pathName = window.location.pathname;
    dispatch(setSandbox(pathName.indexOf('sandbox') !== -1));
  }, [dispatch]);

  return <>{props.children}</>;
};
